import ResourceDetail from "@/src/pages/resource-detail";

export default function TestSeriesDetailPage() {
  return <ResourceDetail type="test_series" backTo="/test-series" label="Test Series" />;
}

